import React from "react";
import Select from "react-select";

const CustomSelect = React.forwardRef(
    ({ overrideClasses, disabled = false, ...props }, ref) => {
        const defaultClassNames = "";
        const classNames = overrideClasses
            ? overrideClasses
            : props.className
            ? `${defaultClassNames} ${props.className}`
            : defaultClassNames;

        const defaultStyles = {
            menu: (base) => ({
                ...base,
                zIndex: 500,
            }),
            control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? "#6366f1" : "rgb(209, 213, 219)",
                paddingTop: "1.5px",
                paddingBottom: "1.5px",
            }),
        };

        const styles = props.styles || defaultStyles;

        return (
            <Select
                ref={ref}
                className={classNames}
                {...props}
                isDisabled={disabled}
                styles={styles}
            />
        );
    }
);

export default CustomSelect;
